export const DEFAULT_BUTTON_THEME_CONFIG = {
  primary: 'hsl(329, 100%, 44%)',
  'primary-border': 'var(--primary)',
  'primary-text': 'hsl(0, 0%, 95%)',
  secondary: 'hsl(0, 0%, 40%)',
  'secondary-border': 'hsl(0, 0%, 40%)',
  'secondary-text': 'hsl(0, 0%, 95%)',
  warning: 'hsl(0, 100%, 50%)',
  'warning-border': 'var(--warning)',
  'warning-text': 'var(--primary-text)',
  success: 'hsl(134, 75%, 37%)',
  'success-border': 'var(--success)',
  'success-text': 'var(--primary-text)',

  'primary-shadow': 'hsla(329, 100%, 44%, 0.4)',
  'secondary-shadow': 'hsla(0, 0%, 40%, 0.4)',
  'warning-shadow': 'hsla(0, 100%, 50%, 0.4)',
  'success-shadow': 'hsla(134, 75%, 37%, 0.4)',

  'outline-hover-opacity': '10%',
  'primary-outline-hover': 'hsla(329, 100%, 44%, var(--outline-hover-opacity))',
  'secondary-outline-hover': 'hsla(0, 0%, 40%, var(--outline-hover-opacity))',
  'warning-outline-hover': 'hsla(0, 100%, 50%, var(--outline-hover-opacity))',
  'success-outline-hover': 'hsla(134, 75%, 37%, var(--outline-hover-opacity))',

  'primary-hover-brightness': '110%',

  'base-box-shadow': '0 0 0 0.2rem',

  'line-clamp': '2',

  'border-width': '2px',

  /* SIZE VARIABLES */
  sm: '0.25rem',
  'sm-font': '0.8em',
  md: '0.5rem',
  'md-font': '1em',
  lg: '0.75rem',
  'lg-font': '1em',
  xl: '1rem',
  'xl-font': '1.2em',
  hMultiplier: '1.75',

  /* ROUND SHAPE VARIABLES */
  'round-base-size': '1.9rem',
  'round-multiplier': '0.4',

  /* CUSTOM CLASSES */
  'plugins-primary': 'var(--primary)',
  'plugins-primary-text': 'var(--primary-text)',
  'plugins-primary-shadow': 'var(--primary-shadow)',
  'plugins-secondary': 'hsl(0, 0, 0)',
  'plugins-secondary-shadow': 'var(--secondary-shadow)',
  'hover-plugins-secondary': 'hsla(0, 0%, 0%, 5%)',
};

export const DEFAULT_VARIANT = 'primary';
export const DEFAULT_SIZE = 'md';
